import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';

@observer
export class AddLabelsForm extends Modal {
  render() {
    const { issueTrackerManager } = modalStore.props;
    const { issuePage: issue } = issueTrackerManager;
    const { addLabelsForm } = issue;
    const {
      conf: { formTitle },
    } = addLabelsForm;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{`${formTitle} to Task #${issue.number}`}</Trans>
        </ModalTitle>
        <Form
          formStore={addLabelsForm}
          formTitle=''
          buttonHandler={issueTrackerManager.AddLabels}
          formTitleCentered={true}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
